import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormService } from '@services/form/form.service';

@Component({
  selector: 'credit-statements-dialog-content',
  templateUrl: './credit-statements-dialog-content.component.html',
  styleUrls: ['./credit-statements-dialog-content.component.scss']
})
export class CreditStatementsDialogContentComponent extends AbstractDialogContent {

  public className = 'CreditStatementsDialogContentComponent';

  constructor(
    public activeModal: NgbActiveModal,
    public formService: FormService,
    injector: Injector
  ) {
    super(activeModal, injector);
  }

  close() {
    this.activeModal.close();
  }
}
